<script setup lang="ts">
import { computed, ref } from 'vue'
import { Setting } from '@/shared/icons'
import { Icon } from '@/shared/ui/Icon'
import { MenuItem } from '@/shared/ui/Menu'
import { useAccount } from '@/apps/adok/entities/account'
import { serverErrorMessage } from '@/shared/api'
import { message } from '@/shared/lib'

const { frozen, allowedPayments, toggleFrozen, togglePayments } = useAccount()

const loading = ref(false)

async function run(action: () => Promise<void>, failure: string) {
  if (loading.value) return
  loading.value = true
  try {
    await action()
  } catch (err) {
    message.error(serverErrorMessage(err, failure))
  } finally {
    loading.value = false
  }
}

const toggles = computed(() => [
  {
    label: 'Frozen',
    value: frozen.value ? 'YES' : 'NO',
    toggle: () => run(toggleFrozen, 'Could not change the frozen status.')
  },
  {
    label: 'Payments',
    value: allowedPayments.value,
    toggle: () => run(togglePayments, 'Could not change the payments status.')
  }
])
</script>

<template>
  <div>
    <MenuItem
      v-for="item in toggles"
      :key="item.label"
      :loading="loading"
      @click="item.toggle"
    >
      <Icon><Setting /></Icon>
      <template #title>
        <span>
          {{ item.label }}: <b>{{ item.value }}</b>
        </span>
      </template>
    </MenuItem>
  </div>
</template>
